import types from "./types";

const initialState = {
  fetchingExpertiseList: false,
  expertiseList: [],
  expertiseListError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_EXPERTISE_REQUEST:
      return {
        ...state,
        fetchingExpertiseList: action.fetchingExpertiseList
      }

    case types.GET_ALL_EXPERTISE_COMPLETE:
      return {
        ...state,
        fetchingExpertiseList: action.fetchingExpertiseList,
        expertiseList: action.expertiseList
      }

    case types.GET_ALL_EXPERTISE_ERROR:
      return {
        ...state,
        fetchingExpertiseList: action.fetchingExpertiseList,
        expertiseListError: action.expertiseListError
      }

    default:
      return state;
  }
};
